import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';

import { AppButton } from '@/components/atoms';
import { type ImportPromiseCta as Cta } from '@/content/importPromise';

/**
 * The band's one action, and the link the whole band exists to be clicked.
 *
 * The arrow nudges on hover and on keyboard focus. In CSS and not through
 * `motion`, for the reason the reveals are also CSS: this button is in the
 * prerendered HTML and has to be complete before the animation runtime
 * arrives on an idle network. A 3px translate needs no library, stays on the
 * compositor, and is suppressed by the reduced-motion rule below rather than
 * by `MotionConfig`.
 *
 * `focus-visible` and not `focus`, so the nudge accompanies a keyboard
 * traversal and does not fire on a mouse click that is already navigating.
 */
export function ImportPromiseCta({ label, to }: Cta) {
  return (
    <AppButton
      to={to}
      size="large"
      endIcon={<ArrowForwardRounded />}
      sx={{
        borderRadius: 999,
        px: 10,
        textTransform: 'none',
        fontWeight: 700,
        width: { xs: '100%', sm: 'auto' },
        '& .MuiButton-endIcon': {
          transition: (t) =>
            t.transitions.create('transform', { duration: t.transitions.duration.shorter }),
        },
        '&:hover .MuiButton-endIcon, &:focus-visible .MuiButton-endIcon': {
          transform: 'translate3d(3px, 0, 0)',
        },
        '@media (prefers-reduced-motion: reduce)': {
          '& .MuiButton-endIcon': { transition: 'none' },
          '&:hover .MuiButton-endIcon, &:focus-visible .MuiButton-endIcon': {
            transform: 'none',
          },
        },
      }}
    >
      {label}
    </AppButton>
  );
}
